import Spinner from '@shared/components/Spinner';
import { LoadingWrapper } from 'compositions/locationDetails/styles';

import { AccountManagerContact, AccountManagerContainer, AccountManagerLabel, AccountManagerName, AccountManagerTagline, AccountMangerContactText } from './style';

interface AccountManagerTabProps {
  name: string;
  email: string;
  phone: string;
  loading?: boolean;
}

export default function AccountManagerTab({ name, email, phone, loading }:AccountManagerTabProps) {

  return (
    <AccountManagerContainer>
      <AccountManagerTagline>Account Manager</AccountManagerTagline>

      {loading && (<LoadingWrapper><Spinner color={'#4DC6CF'} /></LoadingWrapper>)}

      {!loading && (<>
        <AccountManagerName>{ name }</AccountManagerName>

        <AccountManagerLabel>Hi, I'm {name?.split(' ')[0]}. Have a question? Drop me a line</AccountManagerLabel>

        <AccountManagerContact href={`mailto:${email}`}>

          <img src="/message.svg" alt="email" />

          <AccountMangerContactText>
            {email}
          </AccountMangerContactText>

        </AccountManagerContact>

        <AccountManagerContact href={`tel:${phone}`}>

          <img src="/phone.svg" alt="phone" />

          <AccountMangerContactText>
            {phone}
          </AccountMangerContactText>

        </AccountManagerContact>
      </>)
      }
    </AccountManagerContainer>
  )

}
